<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="出账经销商编码" prop="outCusCode">
              <el-input
                v-model="searchForm.outCusCode"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="出账经销商名称" prop="outCusname">
              <el-input
                v-model="searchForm.outCusname"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="入账经销商编码" prop="inCusCode">
              <el-input
                v-model="searchForm.inCusCode"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="入账经销商名称" prop="inCusName">
              <el-input
                v-model="searchForm.inCusName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applyPerson">
              <el-input
                v-model="searchForm.applyPerson"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="操作人" prop="createdName">
              <el-input
                v-model="searchForm.createdName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="操作时间"
              prop="updatedTime"
            >
              <!-- <el-date-picker
                class="date-input"
                size="small"
                v-model="searchForm.updatedTime"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="-"
                start-placeholder="起始时间"
                end-placeholder="截至时间"
              >
              </el-date-picker> -->
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportData">导出</el-button>
          <el-button type="primary" size="small" @click="isTransferPop = true">转账</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="outCusCode" label="出账经销商编码" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outCusName" label="出账经销商名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="amount" label="出账金额(元)" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outCusSurplus" label="出账后钱包余额(元)" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="inCusCode" label="入账经销商编码" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="inCusName" label="入账经销商名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="amount" label="入账金额(元)" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="inCusSurplus" label="入账后钱包余额(元)" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyPerson" label="申请人" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdName" label="操作人" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdTime" label="操作时间" align="center" width="150"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <transfer-pop :isTransferPop.sync="isTransferPop" @transferSuccess="init"/>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import transferPop from './transfer-pop'
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    transferPop
  },
  data() {
    return {
      searchForm: {
        outCusCode: '',
        outCusname: '',
        inCusCode: '',
        inCusName: '',
        applyPerson: '',
        createdName: '',
        startTime: '',
        endTime: '',
      },
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isTransferPop: false,
    };
  },
  methods: {
    init() {
      this.onSearch();
      // this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryTransferList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportData() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryTransferList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}

</style>
